import { render, staticRenderFns } from "./ListGudang.vue?vue&type=template&id=0d3a0825&"
import script from "./ListGudang.vue?vue&type=script&lang=js&"
export * from "./ListGudang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports